type ErrorProps = {
  showError: boolean;
  error: string | undefined;
};

export const TextInputError = (props: ErrorProps) => {
  if (props.showError) return <div className="error-message">{props.error}</div>;
  return null;
};
